/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCostAndUsageAggregationTrendResult extends models.BillingAggregationTrendResult {
    getFixupPrototypeFunction() { return BillingCostAndUsageAggregationTrendResult.fixupPrototype; }

    static newInstance(model: Partial<BillingCostAndUsageAggregationTrendResult>): BillingCostAndUsageAggregationTrendResult {
        let obj = Object.assign(new BillingCostAndUsageAggregationTrendResult(), model);
        BillingCostAndUsageAggregationTrendResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCostAndUsageAggregationTrendResult>): BillingCostAndUsageAggregationTrendResult {
        if (!model) return null;
        return BillingCostAndUsageAggregationTrendResult.newInstance(<BillingCostAndUsageAggregationTrendResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCostAndUsageAggregationTrendResult) {
        if (!obj) return;

        models.BillingCostAndUsageAggregationTrendResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCostAndUsageAggregationTrendResult): boolean {
        if (models.BillingAggregationTrendResult.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingCostAndUsageAggregationTrendResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    rates: Array<number>;

    usages: Array<number>;

    descriptions: Array<string>;

}
